import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataExchangeService {

  pauseCountdown: EventEmitter<void> = new EventEmitter<void>();

  // private _showOnlyBitfinexEnabledAccounts: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  // public showOnlyBitfinexEnabledAccounts: Observable<boolean> = this._showOnlyBitfinexEnabledAccounts.asObservable();

  // private _selectedAccounts: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  // public selectedAccounts: Observable<any[]> = this._selectedAccounts.asObservable();

  // private _cashMovementsFilter: BehaviorSubject<CashMovementsFilter> = new BehaviorSubject<CashMovementsFilter>(null);
  // public cashMovementsFilter: Observable<CashMovementsFilter> = this._cashMovementsFilter.asObservable();

  // private _extSourceRefList: BehaviorSubject<Array<string>> = new BehaviorSubject<Array<string>>(null);
  // public extSourceRefList: Observable<Array<string>> = this._extSourceRefList.asObservable();

  private _changeSidenavStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  public changeSidenavStatus: Observable<boolean> = this._changeSidenavStatus.asObservable();

  // setShowOnlyBitfinexEnabledAccounts(showOnlyBitfinexEnabledAccounts: boolean) {
  //   this._showOnlyBitfinexEnabledAccounts.next(showOnlyBitfinexEnabledAccounts);
  // }
  //
  // setSelectedAccounts(selectedAccounts: any[]) {
  //   this._selectedAccounts.next(selectedAccounts);
  // }
  //
  // setCashMovementsFilter(filter: CashMovementsFilter) {
  //   this._cashMovementsFilter.next(filter);
  // }
  //
  // setExtSourceRefList(value: Array<string>) {
  //   this._extSourceRefList.next(value);
  // }

  setChangeSidenavStatus(status: boolean) {
    this._changeSidenavStatus.next(status);
  }
}
